import React, { useEffect, useState } from 'react';
import {
    LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer
} from 'recharts';

const backURL = process.env.REACT_APP_BACK_URL;

const QuizAnalysis = () => {
    const [data, setData] = useState([]);
    const token = localStorage.getItem('yariyan_gal');

    const getQuizAnalysisData = async () => {
        try {
            const response = await fetch(`${backURL}/quiz-analysis`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            const result = await response.json();
            console.log('Quiz Analysis Data:', result);
            setData(result); // Make sure this matches the actual response

        } catch (error) {
            console.error('Error fetching quiz analysis data:', error);
        }
    };

    useEffect(() => {
        getQuizAnalysisData();
    }, []);

    return (
        <div style={{ width: '100%', height: 400, padding: '20px' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Quiz Analysis - User Scores</h2>

            {data.length === 0 ? (
                <p style={{ textAlign: 'center' }}>No quiz data available.</p>
            ) : (
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data} margin={{ top: 20, right: 30, bottom: 5, left: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="name"
                            angle={-60}
                            textAnchor="end"
                            height={70}
                            tickFormatter={(name) => name.split(' ')[0]} // show only first name
                        />
                        <YAxis />
                        <Tooltip />
                        <Line type="monotone" dataKey="score" stroke="#8884d8" activeDot={{ r: 8 }} />
                    </LineChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default QuizAnalysis;
